import Cookie from 'js-cookie';

import {
  LogEntriesConstantsEnums,
  LogEntryPriorityEnum,
  LogEntryTypesEnums
} from '@nw/shared/config';
import { captureLogEntriesExceptionWithScope, segment } from '@nw/shared/utils';

import { clearUserSession, getUserId } from '../AccountsStorageUtils';

export const clearUserSessionAndReload = (redirectFunction?: () => void) => {
  const cookiesBeforeClearing = Cookie.get();
  const userId = getUserId();
  clearUserSession();
  captureLogEntriesExceptionWithScope(
    LogEntriesConstantsEnums.CLEAR_USER_SESSION_AND_RELOAD,
    {
      path: window.location.href,
      cookiesBeforeClearing,
      cookiesAfterClearing: Cookie.get(),
      cookiesBeforeClearingCount: Object.keys(cookiesBeforeClearing).length,
      cookiesAfterClearingCount: Object.keys(Cookie.get()).length,
      userId
    },
    LogEntryTypesEnums.INFORMATION,
    LogEntryPriorityEnum.MEDIUM
  );
  segment.reset();

  setTimeout(() => {
    if (redirectFunction) {
      redirectFunction();
    } else {
      window.location.reload();
    }
  }, 1000);

  return {
    refresh_token: '',
    access_token: '',
    user_id: '',
    expires_in: ''
  };
};
